/* global dataLayer */
define('businessServices/googleAnalytics/analyticsTracking',['settings/settings'], function () {

    var _settings = require('settings/settings');

    var EVENT = {
        "CreateAccount": {
            eventCategory: 'Acquisition',
            eventAction: 'CreateAccount'
        }
    };

    function trackSignup(lobbyAccountId, total) {
        var isAnalyticsEnabled = _settings.googleAnalyticsEnabled;
        
        if (isAnalyticsEnabled) {
            var analyticsId = _settings.googleAnalyticsTrackingId;
            
            /* jshint ignore:start */
            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

            ga('create', analyticsId, 'auto');
            ga('require', 'ecommerce');
            ga('ecommerce:addTransaction', {
                'id': lobbyAccountId,
                'revenue': total
            });
            ga('ecommerce:send');
            /* jshint ignore:end */
        }
    }

    function trackEvent(event) {
        var isAnalyticsEnabled = _settings.googleAnalyticsEnabled;

        if (isAnalyticsEnabled && event) {
            var analyticsId = _settings.googleAnalyticsTrackingId;

            /* jshint ignore:start */
            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

            (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
                var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', analyticsId);

            ga('create', analyticsId, 'auto', {'name': 'analyticsTracking'});
            ga('analyticsTracking.send', 'event', event);

            try {
                window.dataLayer.push({
                    'event' : event.eventAction
                });
            } catch(ex) {
                // The browser is blocking analytics
            }


            /* jshint ignore:end */
        }
    }

    function trackCreateAccount() {
        trackEvent(EVENT.CreateAccount);
    }

    function trackPageView(path, title) {
        var isAnalyticsEnabled = _settings.googleAnalyticsEnabled;

        if (isAnalyticsEnabled === "true") {
            var analyticsId = _settings.googleAnalyticsTrackingId;

            if (document.getElementById('gtm-noscript') === null) {
                const gtmNoScriptElement = document.createElement("noscript");
                gtmNoScriptElement.id = "gtm-noscript";
                gtmNoScriptElement.innerHTML = `<iframe src="//www.googletagmanager.com/ns.html?id=${analyticsId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
                document.body.insertBefore(gtmNoScriptElement, document.body.firstChild);
            }

            /* jshint ignore:start */
            (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
                var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', analyticsId);

            try {
                window.dataLayer.push({
                    'event': 'pageView',
                    'page': {
                        'url': path,
                        'title': title
                    }
                });
            } catch (ex) {
                // The browser is blocking analytics
            }

            /* jshint ignore:end */
        }
    }

    return {
        trackSignup: trackSignup,
        trackCreateAccount: trackCreateAccount,
        trackPageView : trackPageView
    };
});

